module.exports = __webpack_public_path__ + "img/icon-envelope.dc74a6b6.svg";